import React, { type ReactNode } from 'react'

function ModerationBellIcon(props: React.ComponentPropsWithoutRef<'svg'>): ReactNode {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor"
      {...props}
    >
      <path d="M11.0913 22.9089C12.7377 22.9089 14.115 21.7352 14.4312 20.1816H7.75134C8.06778 21.7352 9.44504 22.9089 11.0913 22.9089Z" />
      <path d="M17.4657 11.999C17.462 11.999 17.4584 11.9999 17.4547 11.9999C13.9466 11.9999 11.0912 9.1453 11.0912 5.6364C11.0912 4.67179 11.3131 3.75994 11.6995 2.93997C11.4994 2.921 11.2966 2.90918 11.0912 2.90918C7.57685 2.90918 4.72779 5.75808 4.72779 9.27264V11.8071C4.72779 13.6062 3.93962 15.3043 2.55686 16.4734C2.09595 16.867 1.89137 17.4942 2.05683 18.1061C2.24958 18.8179 2.9532 19.2725 3.69143 19.2725H18.4866C19.2611 19.2725 19.9912 18.7706 20.1483 18.0116C20.2701 17.4243 20.0611 16.8379 19.6056 16.4552C18.2838 15.3471 17.5193 13.7189 17.4657 11.999Z" />
      <path d="M20.1825 6.40924C20.1825 8.34225 18.6156 9.90918 16.6824 9.90918C14.7494 9.90918 13.1825 8.34225 13.1825 6.40924C13.1825 4.47624 14.7494 2.90918 16.6824 2.90918C18.6156 2.90918 20.1825 4.47624 20.1825 6.40924Z" />
    </svg>
  )
}

export default ModerationBellIcon
